import type { TranslationFn } from '@mentimeter/question-modules-types';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';

export const GroupItemsPreview = ({
  uniqueResponses,
  totalNumberOfResponses,
  translate,
}: {
  uniqueResponses: string[];
  totalNumberOfResponses: number;
  translate: TranslationFn;
}) => {
  const responseWord =
    totalNumberOfResponses === 1
      ? translate('message.response')
      : translate('message.responses');

  return (
    <Box width="100%">
      <Text lineHeight="body" fontSize={4} color="text">
        {totalNumberOfResponses} {responseWord}
      </Text>
      <Text
        fontSize={4}
        color="textWeaker"
        style={{
          maxWidth: '100%',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        {uniqueResponses.map((response) => `”${response}”`).join(', ')}
      </Text>
    </Box>
  );
};
